module.exports = "<app-navbar></app-navbar>\n<app-keyboard></app-keyboard>\n<br>\n<br>\n<app-answer></app-answer>\n"


//////////////////
// WEBPACK FOOTER
// /Users/ericzayas/Documents/relativePitch/src/app/components/home/home.component.html
// module id = ../../../../../src/app/components/home/home.component.html
// module chunks = main